import axios from 'axios'
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}/admin`
const SUGARCOACH_BASE_URL = `${process.env.REACT_APP_BACKEND_HOST}`

const axiosInstance = axios.create()

//요청 가로채기
axiosInstance.interceptors.request.use(
  //요청 보내기전 수행
  async function (config) {
    const recoilValue = localStorage.getItem('recoil-persist')
    // console.log('recoilValue = ', recoilValue)
    if (recoilValue !== null) {
      const parserdRecoilValue = JSON.parse(recoilValue)
      // console.log('tokenInfo = ', parserdRecoilValue?.token)
      if (
        parserdRecoilValue !== null &&
        parserdRecoilValue?.token?.accessToken &&
        parserdRecoilValue?.token?.refreshToken
      ) {
        // config.headers['x-dy-accesstoken'] =
        //   parserdRecoilValue.token.accessToken
        // config.headers['x-dy-refreshToken'] =
        //   parserdRecoilValue.token.refreshToken
      }
    }
    return config
  },
  //오류 요청
  function (err) {
    return Promise.reject(err)
  },
)

/**
 * 문의 카테고리 목록 조회
 * @param param isTotal: '전체' 카테고리 포함 여부, isAdmin: 관리자 권한 여부
 */
const readCategoryList = async (param) => {
  const res = await axiosInstance.get(`${baseUrl}/inquiry/read/list/category`, {
    params: param,
  })
  return res
}

/**
 * 문의 목록 조회
 * @param param offset
 * @param param pageSize
 * @param param answerStatus 문의 답변 여부
 * @param param inquiryType 문의 유형
 * @param param orderType 정렬 유형
 * @param param orderBy 정렬 순서 (desc-최신순/asc-오래된순)
 */
const readInquiryList = async (param) => {
  const res = await axiosInstance.get(`${baseUrl}/inquiry/read/list`, {
    params: param,
  })
  return res
}

/**
 * 문의 답변 등록하기
 * @param param id, answer_content, created_by
 */
const createInquiryAnswer = async (param) => {
  const res = await axiosInstance.post(
    `${baseUrl}/inquiry/create/answer`,
    param,
  )
  return res
}

/**
 * 문의 답변 수정하기
 * @param param id, answer_content, created_by
 */
const editInquiryAnswer = async (param) => {
  const res = await axiosInstance.post(`${baseUrl}/inquiry/edit/answer`, param)
  return res
}

const readProductInquiryOne = async (param, userId) => {
  const res = await axios.get(`${baseUrl}/product-inquiry/one`, {
    params: param,
    headers: {
      userId: userId,
    },
  })
  return res
}

const readProductInquiryList = async (param, userId) => {
  const res = await axios.get(`${baseUrl}/product-inquiry/list`, {
    params: param,
    headers: {
      userId: userId,
    },
  })
  return res
}

const createProductInquiryAnswer = async (param, userId) => {
  const res = await axios.post(
    `${baseUrl}/product-inquiry/create/answer`,
    param,
    {
      headers: {
        userId: userId,
      },
    },
  )
  return res
}

const editProductInquiryAnswer = async (param, userId) => {
  const res = await axios.post(
    `${baseUrl}/product-inquiry/edit/answer`,
    param,
    {
      headers: {
        userId: userId,
      },
    },
  )
  return res
}

const deleteProductInquiryAnswer = async (param, userId) => {
  const res = await axios.delete(
    `${baseUrl}/product-inquiry/delete/answer`,
    param,
    {
      headers: {
        userId: userId,
      },
    },
  )
  return res
}

/**
 * 리뷰 목록 조회
 * @param param
 * offset: offset
 * pageSize: pageSize
 * startDate: 시작일 YYYYMMDDHHmm
 * endDate: 종료일 YYYYMMDDHHmm
 * reviewStatus: 리뷰 유형 "total"-전체/"photo"-포토/"text"-텍스트
 * reviewGrade: 별점 0-전체/1~5-1~5점
 * benefitPayment: 혜택 지급 "total"-전체/"true"-지급/"false"-미지급
 * exposureStatus: 전시 상황 "total"-전체/"true"-정상/"false"-미노출
 * bestReview: 베스트 리뷰 여부 "total"-전체/"true"-베스트 리뷰 Y/"false"-베스트 리뷰 N
 * searchType: 상세검색 키 "product"-상품명/"product_id"-상품번호/"order_id"-상품주문번호/"review_body"-내용
 * searchText: 상세검색어
 * orderType: 정렬 기준 "created_at"-리뷰등록일순/"review_score"-평점순/"review_private"-전시상태순/"is_best"-베스트리뷰순
 * orderBy: 정렬 방향 "desc"-내림차순/"asc"-오름차순
 * userId: 사용자 아이디
 * @returns {Promise<never>}
 */
const readReviewList = async (param, userId) => {
  const res = await axios.get(`${baseUrl}/review/list`, {
    params: param,
    headers: {
      userId: userId,
    },
  })
  return res
}

/**
 * 리뷰 상세페이지 조회
 * @param param
 * @returns {Promise<never>}
 */
const getReviewDetail = async (param, userId) => {
  const res = await axios.get(`${baseUrl}/review/one`, {
    params: param,
    headers: {
      userId: userId,
    },
  })
  return res
}

/**
 * 리뷰 미노출/노출 처리
 * @param review
 * user_id: user.id
 * editList: rowkeys,
 * editkey: "review_private"/"is_best",
 * editvalue : 0-노출, 1-미노출
 * is_best: true/false
 * @returns {Promise<*>}
 */
const editReview = async (param, userId) => {
  const res = await axios.post(`${baseUrl}/review/edit`, param, {
    headers: {
      userId: userId,
    },
  })
  return res
}

/**
 * 엑셀 리뷰 업로드
 * @param param
 * reviewList: list []
 * product_id,
 * review_body,
 * review_score,
 * created_at
 * @returns {Promise<*>}
 */
const addReviewListExcel = async (param, userId) => {
  const res = await axios.post(`${baseUrl}/review/list/create`, param, {
    headers: {
      userId: userId,
    },
  })
  return res
}

const getImageS3URL = async (contentType, category) => {
  try {
    const res = await axiosInstance.post(
      `${SUGARCOACH_BASE_URL}/v2/files/signed-url`,
      {
        params: {
          category,
          contentType,
        },
      },
    )
    return res.data
  } catch (err) {
    console.error('이미지 url 불러오기 실패', err)
    throw err
  }
}

const getProductReviewList = async ({ params, userId }) => {
  try {
    const res = await axiosInstance.get(
      `${SUGARCOACH_BASE_URL}/v2/product-reviews`,
      params,
      {
        headers: {
          userId: userId,
        },
      },
    )
    return res.data
  } catch (err) {
    console.error('getProductReviewList ::', err)
    throw err
  }
}

//이미지 파일 조회
const getReviewImage = async ({ category, uniqueId }) => {
  try {
    const res = await axiosInstance.get(
      `${SUGARCOACH_BASE_URL}/v2/admin/files`,
      {
        params: {
          category,
          uniqueId,
        },
      },
    )
    return res.data
  } catch (err) {
    console.error('getReviewImage ::', err)
    throw err
  }
}

const inquiryApi = {
  readCategoryList,
  readInquiryList,
  createInquiryAnswer,
  editInquiryAnswer,

  readProductInquiryOne,
  readProductInquiryList,
  createProductInquiryAnswer,
  editProductInquiryAnswer,
  deleteProductInquiryAnswer,

  readReviewList,
  getReviewDetail,
  editReview,
  addReviewListExcel,
  getImageS3URL,

  getProductReviewList,
  getReviewImage,
}
export default inquiryApi
